import React, { Component } from 'react';
import './About.css';
import Dropdown from '../Dropdown';
import {Link} from 'react-router-dom';
import RightMenu from "../RightMenu";
import PartnersContent from "../PartnersContent";
export default class About extends Component{

	constructor(props){
		super(props);
		//console.log(props);
		this.state = {
			data: props.data.article,
			rightMenu: props.data.right_menu||[],
			// prevDropdown: props.data.prev_dropdown,
			// rightMenu: [],
			config: props.hasOwnProperty('config') ? props.config : [],
			prevDropdown: props.data.hasOwnProperty('prev_dropdown') ? props.data.prev_dropdown : [],
		}
	}

	render(){
		// Handle both old and new data structures
		const data = this.state.data || {};
		const article = data.article || data;
		const lead = article.lead;
		const title = article.title;
		const text = article.text;
		const cover_photo = article.cover_photo;
		
		var mobile_lead = lead ? <div className="mobile_lead"><div className="mobile_lead_inner" dangerouslySetInnerHTML={{ __html: lead }}></div></div> : null;
		var about_text_style = lead ? {paddingTop: 15} : null;
		//console.log('About',this.state);
		
		// Check if this is partners page
		const isPartnersPage = window.location.pathname.includes('partnerzy') || window.location.pathname.includes('partners');

		return (
			<div className="About">
				<div className="row">
					<div className="about_title artists-pageTitle col-sm-9" dangerouslySetInnerHTML={{ __html: title }}></div>
					<div
						className={`
							? "vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3 dropdown--nav-flex"
							: "vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3"
						`}
						>
							{this.state.prevDropdown.length ||
								Object.keys(this.state.prevDropdown).length ? (
									<Dropdown
										giveMeClassName={`${
											this.state.prevDropdown.dates.length > 5
											? "festiwal--dropdown"
											: "normal"
										}`}
										data={this.state.prevDropdown}
									/>
								) : null}
							</div>
				</div>
				{!isPartnersPage && (
					<div className="about-topbanner-box">
						<div className="about_img_block" style={{backgroundImage: "url(" + cover_photo + ")"}}>
							<div className="about-colorbox" style={{backgroundColor: '#'+this.state.config.gbcolor}}></div>
						</div>
					</div>
				)}

				<div className="about-content left col-xs-12 col-sm-10 col-md-9 col-lg-9">
					<div className="mobileMenu">
						<ul>
							{this.state.rightMenu.map(function(object, i){
								return (<li className="about-grightMenu" key={object.id}><Link to={"/"+object.url}>{object.name}</Link></li>);
							})}
						</ul>
					</div>


				{mobile_lead}
				{isPartnersPage ? (
					<PartnersContent />
				) : (
					<div className="about_text" style={about_text_style} dangerouslySetInnerHTML={{ __html: text }}></div>
				)}

			</div>
				<div className="right col-xs-2 col-sm-2 col-md-3 col-lg-3">

				{/* {	 this.state.prevDropdown.length || Object.keys(this.state.prevDropdown).length ? <Dropdown data={this.state.prevDropdown} /> : null} */}

				{/* {this.state.prevDropdown.length || Object.keys(this.state.prevDropdown).length ? <Dropdown data={this.state.prevDropdown} /> : null} */}
					<div className="disctopMenuright">
						<ul>
							{this.state.rightMenu.map(function(object, i){

							return (<li className="about-grightMenu" key={object.id}><Link to={"/"+object.url}>{object.name}</Link></li>);
							})}
						</ul>
					</div>


				</div>
			</div>
		);

	}

}



// WEBPACK FOOTER //
// ./src/Components/Elements/About/About.js